import React, { useMemo } from "react";
import "./styles.scss";
import { tt } from "../../utils/i18n/i18n";
import {
  useAccountToDisplaySelector,
  useManagedAccountsSelector,
  useMasterTokenSelector
} from "../../redux/actions/user";
import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import { type KC_TabItem } from "../../designsystem/KC_Tabs/KC_Tabs";
import JetpackConfigurator from "./JetpackConfigurator";
import KC_Tabs_Border_WithEdit from "./components/KC_Tabs_Border_WithEdit/KC_Tabs_Border_WithEdit";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import NiceModal from "@ebay/nice-modal-react";
import EditPlaceNameModal from "../../components/modal/EditPlaceNameModal/EditPlaceNameModal";
import { useHistory } from "react-router-dom";
import { buildPathWithTrackingId } from "../../utils/routing/routingUtils";
import { JETPACK_CONFIG } from "../../utils/routes/routes";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import KC_Button from "../../designsystem/KC_Button/KC_Button";
import { startAccountCreationFlow } from "../../utils/flows/startAccountCreationFlow";
import { useDispatch } from "react-redux";

export const JetpackConfiguratorWrapper = () => {
  const managedAccounts = useManagedAccountsSelector();
  const { accountToDisplayIndex } = useAccountToDisplaySelector();
  const masterToken = useMasterTokenSelector();
  const dispatch = useDispatch();
  const history = useHistory();

  const onChangeDisplayAccount = (newAccount: ManagedAccount) => {
    if (!newAccount.trackingID) {
      alert(tt("error"));
      return;
    }
    history.push(
      buildPathWithTrackingId(JETPACK_CONFIG, newAccount.trackingID)
    );
  };

  const getAccountByTrackingId = (trackingId: string) => {
    const account = managedAccounts.find(
      (acc) => acc.trackingID === trackingId
    );
    return account || managedAccounts[0];
  };

  const handleEditClick = async (account: ManagedAccount) => {
    await NiceModal.show(EditPlaceNameModal, { managedAccount: account });
  };

  const ITEMS: KC_TabItem[] = useMemo(() => {
    return managedAccounts
      .filter(
        (account) => !account.businessUser?.hide && account.email !== "all"
      )
      .map((account, index) => {
        return {
          name: account.placeName
            ? account.placeName
            : `${tt("jp_default_place_name")} ${index + 1}`,
          value: account.trackingID ? account.trackingID : index.toString()
        };
      });
  }, [managedAccounts]);

  const handleAddVenue = async () => {
    if (!masterToken) {
      alert(tt("error"));
      return;
    }
    await startAccountCreationFlow(masterToken, dispatch, history);
  };

  if (!managedAccounts) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-lg page-padding-standard dashboard-v2">
      <div className="d-flex flex-column st-gap">
        <KC_Heading2 text={tt("yourAnimationsHeading")} />
        <KC_Tabs_Border_WithEdit
          items={ITEMS}
          selectedIndex={accountToDisplayIndex}
          onSelect={(trackingId) => {
            const account = getAccountByTrackingId(trackingId);
            onChangeDisplayAccount(account);
          }}
          onEditClick={handleEditClick}
          managedAccounts={managedAccounts}
          additionalButtons={
            <KC_Button
              id="add-venue-btn"
              isPrimary={false}
              isInverted={false}
              isSecondary={false}
              isWhite={true}
              text={tt("new_venue_add")}
              showIconOnTheLeft={true}
              icon={faPlus}
              onClick={handleAddVenue}
              extraStyle={{
                width: "unset ",
                height: 50,
                border: "1px solid #DDD"
              }}
            />
          }
        />
      </div>
      <JetpackConfigurator />
    </div>
  );
};
